import React, { useContext, useEffect, useState } from 'react';
import {
  Box, Button, Container, Divider, IconButton, Skeleton,
} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { ArrowBackRounded } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import Images from '../../../../Configs/images';
import ROUTES from '../../../../Configs/routes';
import { getUserData } from '../../../../Utils/storages';
import Elements from '../../../Elements';
import AlertContext from '../../../../Context/AlertContext';
import { getSubscriptions } from '../../../../Redux/Models/master';

export default function SubscriptionPackage({ classes }) {
  const navigate = useNavigate();
  const userData = getUserData() || {};
  const dispatch = useDispatch();
  const { openAlert } = useContext(AlertContext);
  const { t } = useTranslation();
  const {
    subscriptions,
    isLoadingSubscriptions,
    errorSubscriptions,
    subscriptionsMessage,
  } = useSelector((state) => state.master);
  const [subscription, setSubscription] = useState([]);

  const getData = () => {
    dispatch(getSubscriptions());
  };

  useEffect(() => {
    getData();
  }, []);

  useEffect(() => {
    const selected = subscriptions.filter((sub) => sub.name === userData.subscription);
    if (selected.length) {
      setSubscription(selected[0]);
    }
  }, [subscriptions]);

  useEffect(() => {
    if (errorSubscriptions) {
      openAlert({
        severity: 'error',
        message: subscriptionsMessage || 'Something went wrong',
      });
    }
  }, [errorSubscriptions]);

  const renderSubscription = () => {
    if (isLoadingSubscriptions) {
      return (
        <Box className="package-box mt-4">
          <div className="regular" />
          <div className="detail-container">
            <div className="flex gap-16 mt-2 align-items-center">
              <Skeleton variant="circular" width={42} height={42} />
              <Skeleton variant="text" width={100} height={24} />
            </div>

            <Divider sx={{ my: 2 }} />

            <Skeleton variant="text" width={100} />
            <Skeleton variant="text" width={100} />
            <Skeleton variant="text" width={100} />

            <Divider sx={{ my: 2 }} />

            <div className="flex mt-1 align-items-center space-between">
              <div className="weight-700 s-16">
                <Skeleton variant="rectangular" className="rounded" width={120} height={24} />
              </div>
              <Skeleton variant="rectangular" className="rounded" width={100} height={32} />
            </div>
          </div>
        </Box>
      );
    }

    if (subscription.id) {
      return (
        <Box className="package-box mt-4">
          <div className="regular" />
          <div className="detail-container">
            <div className="flex gap-16 mt-2 align-items-center">
              <img alt="star" src={subscription.images[0]} width="42" height="42" className="circle" />
              <div className="weight-700 s-16">{subscription.name}</div>
            </div>

            <Divider sx={{ my: 2 }} />

            {subscription.package_benefit?.map((benefit) => (
              <li className="mt-1" key={benefit}>{benefit}</li>
            ))}

            <div className="mt-3" hidden={!subscription.upgradeOption}>
              <Button className="btn-outlined" fullWidth onClick={() => navigate(ROUTES.subscriptionPackage())}>Upgrade Plan</Button>
            </div>
          </div>
        </Box>
      );
    }

    return null;
  };

  return (
    <Elements.PageBase navigate={navigate}>
      <div className={classes.root}>
        <IconButton onClick={() => navigate(-1)} sx={{ mt: 2, ml: 2 }}>
          <ArrowBackRounded />
        </IconButton>
        <div className="center">
          <img src={Images.Logo} alt="box pack" className="mt-2" />
          <h4 className="mt-4">{t('subs.package')}</h4>
          <div className="s-16 mt-3 height-14">
            {t('subs.registered')}
            {' '}
            {userData.subscription}
          </div>
        </div>

        <Container>
          {renderSubscription()}
        </Container>

        {/* <div className="floating-action">
          <Container>
            <Button className="btn-contained" fullWidth>See Boxpack subcription package</Button>
          </Container>
        </div> */}
      </div>
    </Elements.PageBase>
  );
}
